import React from "react";
import { useSelector } from "react-redux";

import Toolbar from "@mui/material/Toolbar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  TableHead: {
    position: "sticky",
    top: "0px",
    zIndex: 2,
    backgroundColor: "rgb(255, 255, 255)",
    whiteSpace: "nowrap",
  },
  Panel: {
    borderRadius: "4px",
    marginBottom: 0,
  },
  PanelTitle: {
    padding: 5,
    minHeight: 40,
  },
}));

const TableCells = ({ row }) =>
  row.map((col, i) => {
    return (
      <TableCell key={i} component="th" scope="row" padding="normal">
        {col}
      </TableCell>
    );
  });

const TableRows = ({ columns }) => {
  const headerCount = columns.headers.length;
  return columns.data.map((row, i) => {
    return row.length === headerCount ? (
      <TableRow key={i}>
        <TableCells row={row} />
      </TableRow>
    ) : row?.every((element) => element.trim() === "") ? (
      <TableRow key={i}>
        <TableCell sx={{ color: "info.main", textAlign: "center" }} colSpan={headerCount}>
          {`Row ${i + 1}: Empty Row`}
        </TableCell>
      </TableRow>
    ) : (
      <TableRow key={i}>
        <TableCell sx={{ color: "red", textAlign: "center" }} colSpan={headerCount}>
          {`Row ${i + 1}: Data mismatched/Incorrect "Source File Properties" selection`}
        </TableCell>
      </TableRow>
    );
  });
};

const PreviewTable = ({ columns }) => {
  const { classes } = useStyles();
  const previewCount = useSelector((state) => state.config.previewCount);

  return (
    <>
      <Toolbar
        className={classes.PanelTitle}
        sx={{
          maxHeight: "40px",
        }}
      >
        <span
          style={{
            color: "#ed6c02",
            padding: "0",
            margin: "0",
          }}
        >
          Sample Data from file:
        </span>
        {![undefined, null, ""].includes(columns.fileName) && (
          <span style={{ padding: "0", margin: "0", marginLeft: "7px" }}>{columns.fileName}</span>
        )}
        <span
          style={{
            padding: "0",
            margin: "0",
            marginLeft: "7px",
            fontSize: "0.85rem",
          }}
        >
          ({`First ${previewCount} rows`})
        </span>
      </Toolbar>
      <Paper
        elevation={3}
        className={classes.Panel}
        sx={{
          "& .MuiPaper-root": {
            height: "calc(100% - 40px)",
          },
        }}
      >
        <TableContainer style={{ maxHeight: "30vh" }}>
          {columns.data.length ? (
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  {columns.headers.map((header, i) => (
                    <TableCell key={i} className={classes.TableHead} style={{ fontWeight: 600 }}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRows columns={columns} />
              </TableBody>
            </Table>
          ) : (
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    align="center"
                    colSpan={columns.headers.length}
                    sx={{ fontWeight: "bolder", fontSize: "1rem", color: "#0288d1" }}
                  >
                    {columns.error || "Unable to read sample data. However, you can still proceed to import."}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Paper>
    </>
  );
};

export default React.memo(PreviewTable);
